import { TranslateLoader } from '@ngx-translate/core';
import { catchError, Observable, of } from 'rxjs';

/**
 * A language file that fails to load leaves that language empty, so its texts resolve from the fallback language.
 * Without this, the error would fail the language switch or, for the initial language, the whole app bootstrap.
 */
export class FailSafeTranslateLoader implements TranslateLoader {
  constructor(private readonly loader: TranslateLoader) {}

  getTranslation(lang: string): Observable<Record<string, unknown>> {
    return this.loader.getTranslation(lang).pipe(
      catchError(error => {
        console.error(`[i18n] Could not load translations "${lang}"`, error);
        return of({});
      })
    );
  }
}
